import { BASE_URL } from "../App/Configs/AppConfig";
import ApiHelper from "../App/Utils/APIHelper";

export default class AuthDataProvider {
  apiHelper = new ApiHelper(BASE_URL);

  post_api_call = async (url, values) =>
    await this.apiHelper.apiCall(url, "POST", values);

  get_api_call = async (url) =>
    await this.apiHelper.apiCall(url, "GET", null);
}
